import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Media range syntax does not have 100% support yet. Prefer e.g. max-width until
 * that has improved. Range syntax fine in CSS/SCSS files due to postcss plugin.
 * @see useIsMediaLessThan for a syntax improvement
 */
export default function useMediaQuery(query: string): boolean {
  const mediaQuery = useRef(window.matchMedia(query));
  const [matches, setMatches] = useState(mediaQuery.current.matches);

  const handleMediaEvent = useCallback((event: MediaQueryListEvent) => {
    setMatches(event.matches);
  }, []);

  useEffect(() => {
    const mq = mediaQuery.current;
    mq.addEventListener("change", handleMediaEvent);
    return () => {
      mq.removeEventListener("change", handleMediaEvent);
    };
  }, [handleMediaEvent]);

  return matches;
}
